import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[750px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20atmospheric%20Korean%20manhwa%20style%20collage%20of%20epic%20characters%20silhouettes%20dramatic%20lighting%20black%20and%20dark%20gray%20tones%20with%20subtle%20warm%20orange%20and%20teal%20accents%20abstract%20comic%20panel%20composition%20modern%20artistic%20wallpaper%20cinematic%20mood%20high%20contrast&width=1440&height=800&seq=hero-bg-manhwa&orientation=landscape"
          alt="073漫画网 - 免费韩漫大全"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-20">
        <div className="flex flex-col items-center text-center">
          <p className="text-accent-400 font-label text-xs md:text-sm tracking-[0.3em] uppercase mb-4">
            ● 每日更新 · 无删减 · 下拉式
          </p>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-50 leading-tight max-w-3xl">
            免费韩漫大全
            <br />
            <span className="text-primary-400">无删减下拉式阅读</span>
          </h1>

          <p className="mt-6 text-sm md:text-base text-foreground-300 max-w-xl leading-relaxed">
            热血少年、浪漫爱情、悬疑惊悚——全类型韩国漫画持续更新中。<br className="hidden sm:block" />
            原汁原味无删减，下拉式流畅阅读，打开即看无需等待。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/category/action"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-label font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/10 text-foreground-200 border border-foreground-500/30 rounded-full text-sm font-label hover:bg-background-50/20 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-12 flex items-center gap-2">
            <div className="flex -space-x-2">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-400 border-2 border-background-50 flex items-center justify-center text-[10px] font-label text-foreground-600"
                >
                  <i className="ri-user-line"></i>
                </div>
              ))}
            </div>
            <span className="text-xs md:text-sm text-foreground-400 ml-2">
              <strong className="text-foreground-200">890万+</strong> 韩漫爱好者共同选择
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent z-10"></div>
    </section>
  );
}